import { jsx } from "react/jsx-runtime";
import MortgageQuestionnaire from "./MortgageQuestionnaire.esm.js";
const MortgageQuestionnareBlock = {
  Component: ({
    attrs
  }) => {
    const {
      pathName = "/mortgage-rates/",
      landingPage = "mortgage-rates"
    } = attrs;
    return /* @__PURE__ */ jsx(MortgageQuestionnaire, { ...{
      pathName,
      landingPage
    } });
  },
  metadata: {
    version: "1.0",
    name: "constellation/mortgage-questionnaire",
    title: "Mortgage Questionnare",
    description: "Compare today's mortgage rates and get a customized quote from a lender that fits your needs.",
    icon: "businessperson",
    keywords: ["mortgages", "quizes"],
    supports: {
      customClassName: false,
      html: false
    },
    category: "Information",
    attributes: {
      pathName: {
        type: "string",
        label: "Default pathname",
        default: "/mortgage-rates/",
        control: "text"
      },
      landingPage: {
        //When accessing refinance page then landingPage value will be refinance
        type: "string",
        label: "Default landing page",
        default: "mortgage-rates",
        control: "text"
      }
    }
  }
};
export {
  MortgageQuestionnareBlock as default
};
